import { normalizarData, normalizarValor } from '../../utils/index';

const superNormalize = (h) => {
    return String(h || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim()
        .toLowerCase();
};

const superNormalizeNoSpace = (h) => {
    return superNormalize(h).replace(/[^a-z0-9]/g, '');
};

export const detectar = (dadosArray) => {
    for (let i = 0; i < Math.min(dadosArray.length, 10); i++) {
        const linha = dadosArray[i];
        if (!linha || !Array.isArray(linha)) continue;

        const cleanRow = linha.map(superNormalizeNoSpace);
        
        if (
            cleanRow.includes('dia') && 
            cleanRow.includes('descricao') &&
            cleanRow.includes('tipo') &&
            cleanRow.includes('valor') &&
            cleanRow.includes('hora')
        ) {
            return true;
        }
    }
    return false;
};

export const processar = (dadosArray) => {
    let idxCabecalho = -1;
    let colMap = {};

    for (let i = 0; i < Math.min(dadosArray.length, 10); i++) {
        const linha = dadosArray[i];
        if (!linha || !Array.isArray(linha)) continue;

        const cleanRow = linha.map(superNormalizeNoSpace);
        
        if (cleanRow.includes('dia') && cleanRow.includes('descricao') && cleanRow.includes('valor')) {
            idxCabecalho = i;
            cleanRow.forEach((h, idx) => {
                if (h) colMap[h] = idx;
            });
            break;
        }
    }

    if (idxCabecalho === -1) {
        throw new Error('Cabeçalho de Extrato Cappta não encontrado.');
    }

    const extrato = [];
    for (let i = idxCabecalho + 1; i < dadosArray.length; i++) {
        const linha = dadosArray[i];
        if (!linha || linha.length === 0) continue;

        const idxData = colMap['dia'];
        const dataStr = String(linha[idxData] || '').trim();
        if (!dataStr) continue;

        const data = normalizarData(dataStr);
        if (!data) continue;

        const idxTipoColuna = colMap['tipo'];
        const tipoMovimento = idxTipoColuna !== undefined ? String(linha[idxTipoColuna] || '').trim().toLowerCase() : '';

        // Aceitamos apenas entradas
        if (tipoMovimento && tipoMovimento === 'saida') {
            continue;
        }

        const idxValor = colMap['valor'];
        let valorStr = String(linha[idxValor] || '').trim();
        if (!valorStr) continue;

        const idxDescricao = colMap['descricao'];
        let descricao = idxDescricao !== undefined ? String(linha[idxDescricao] || '').trim() : 'Cappta';
        
        let valor = normalizarValor(valorStr);

        // Garantir que é um crédito (valor > 0)
        if (valor !== null && valor > 0) {
            extrato.push({
                linha: i + 1,
                data: data,
                valor: valor,
                tipo: descricao,
                dataOriginal: dataStr,
                valorOriginal: valorStr
            });
        }
    }

    return extrato;
};
